import * as React from "react";
import { withStyles } from "src/decorators";
import styled, { css, DefaultTheme } from "styled-components";
import { Box } from "src/components/Box";

type Props = {
  color?: keyof DefaultTheme["colors"]["background"];
  children?: React.ReactNode;
  icon?: React.ReactNode;
};

const AlertBoxEl = styled.div<Props>`
  display: flex;
  border: 1px solid currentColor;
  flex-wrap: wrap;
  line-height: 1.2;
  position: relative;
  width: 100%;

  ${(p) => css`
    align-items: ${p.theme.alertBox.alignItems};
    margin: ${p.theme.dimension.spacing.l}px 0;
    padding: ${p.theme.dimension.spacing.m}px;
    border-radius: ${p.theme.dimension.borderRadius[0]}px;
    font-size: ${p.theme.text.size.medium};
    box-shadow: ${p.theme.alertBox.boxShadow};
    color: ${p.theme.alertBox.colors[p.color!]};
  `}
`;

const BackgroundEl = styled.div<Props>`
  bottom: 0;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;

  ${(p) => css`
    background: ${p.theme.colors.background[p.color!]};
    opacity: ${p.theme.alertBox.opacity};
    z-index: ${p.theme.alertBox.zIndex};
  `}
`;

export const AlertBox = withStyles(
  ({ children, color = "primary", icon, ...other }: Props) => (
    <AlertBoxEl {...other} color={color}>
      <BackgroundEl color={color} />
      {icon && <Box marginRightM>{icon}</Box>}
      {children && (
        <Box flexGrow flexShrink flexBasis0>
          {children}
        </Box>
      )}
    </AlertBoxEl>
  )
);
